export default {"src":"/_next/static/media/drawer-menu.0729cd53.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};